import React from "react";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const AppEditor = (props) => {
  const { onChange, data } = props;

  const editorConfig = {
    toolbar: [
      "bold",
      "italic",
      "blockquote",
      "|",
      "numberedlist",
      "bulletedlist",
      "|",
      "link",
      "|",
      "undo",
      "redo",
    ],
  };

  return (
    <div className="App">
      <CKEditor
        editor={ClassicEditor}
        config={editorConfig}
        data={data}
        onInit={(editor) => {
          // You can store the "editor" and use when it is needed.
          // console.log("Editor is ready to use!", editor);
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange({ event, editor, data });
        }}
        onBlur={(event, editor) => {
          console.log("Blur.", editor);
        }}
        onFocus={(event, editor) => {
          console.log("Focus.", editor);
        }}
      />
    </div>
  );
};

export default AppEditor;
